import { render, staticRenderFns } from "./AddEditBatchEndpointModal.vue?vue&type=template&id=d272da3a&scoped=true"
import script from "./AddEditBatchEndpointModal.vue?vue&type=script&lang=js"
export * from "./AddEditBatchEndpointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d272da3a",
  null
  
)

export default component.exports